import * as TYPES from './types';

// Set loading to true for next render
const clearMovies = () => ({type: TYPES.SET_MOVIES_LOADING});

export default clearMovies;
